import React, { useEffect } from 'react';
import { useSessionContext } from '../contexts/sessionContext';
import LoadingScreen from '../components/LoadingScreen';
import { useRouter } from 'next/router';

export const withAuthentication = (newProps = {}) => (Component) => {
  return (props) => {
    const session = useSessionContext();
    const router = useRouter();

    const { isAuthenticated, loading, login } = session;

    useEffect(() => {
      if (!isAuthenticated && !loading) {
        login();
      }
    }, [loading, isAuthenticated]);

    if (loading || !isAuthenticated) {
      return <LoadingScreen session={session} />;
    }
    if (session.tripsTotal && router.pathname === '/') {
      router.push('/truck/dashboard');
      return null;
    }

    return <Component {...newProps} {...props} session={session} />;
  };
};
